// Libs
import React from "react";
import { Card, Form, Button, Divider, Input, Typography } from "antd";

import logo from "@assets/logo-name.svg";
import microsoftLogo from "@assets/microsoft.svg";
import BackGroundAnimation from "../../components/BackGroundAnimation";
import * as S from "./style";
import { useLogin } from "./useLogin";

function Login() {
  const {
    onFinishAzure,
    onFinishBackend,
    isAzureLoading,
    isBackendLoading,
    goToResetPassword,
  } = useLogin();

  return (
    <S.Container>
      <BackGroundAnimation />
      <S.Part>
        <S.ContainerCard>
          <Card
            hoverable
            style={{ borderRadius: "10px" }}
            cover={
              <S.HeaderCard>
                <img src={logo} alt="logo" />
              </S.HeaderCard>
            }
          >
            <S.HeaderWelcome style={{ textAlign: "center" }}>
              <h4 className="mb-2">Bem vindo(a).</h4>
              <span>(Entre com seu email e senha)</span>
            </S.HeaderWelcome>

            <Form
              className="mt-2"
              name="login-backend"
              layout="vertical"
              onFinish={onFinishBackend}
            >
              <Form.Item
                label="E-mail"
                name="email"
                rules={[
                  { required: true, message: "Informe seu e-mail" },
                  { type: "email", message: "Informe um e-mail válido" },
                ]}
              >
                <Input placeholder="seuemail@dominio.com" />
              </Form.Item>

              <Form.Item
                label="Senha"
                name="password"
                rules={[{ required: true, message: "Informe sua senha" }]}
              >
                <Input.Password placeholder="Sua senha" />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  style={{
                    width: "180px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "5px auto 0 auto",
                  }}
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  loading={isBackendLoading || isAzureLoading}
                >
                  Entrar
                </Button>
              </Form.Item>

              <S.ButtonsBox>
                <S.ForgotPassword onClick={goToResetPassword}>
                  Esqueci minha senha
                </S.ForgotPassword>
                <S.Account
                  href="https://app.pipefy.com/public/form/tR8__Abt"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Solicitar acesso
                </S.Account>
              </S.ButtonsBox>
            </Form>

            <Form
              className="mt-2"
              name="login-azure"
              layout="vertical"
              onFinish={onFinishAzure}
            >
              <Form.Item style={{ marginBottom: 0 }}>
                <Divider style={{ margin: "16px 0" }}>
                  <Typography.Text type="secondary">ou</Typography.Text>
                </Divider>

                <Button
                  style={{
                    width: "220px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "5px auto 0 auto",
                    backgroundColor: "#0078D4",
                    borderColor: "#0078D4",
                  }}
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  loading={isAzureLoading || isBackendLoading}
                  icon={
                    <img
                      src={microsoftLogo}
                      alt="Microsoft"
                      style={{ width: 18, height: 18, marginRight: 8 }}
                    />
                  }
                >
                  {isAzureLoading ? "Aguarde..." : "Entrar com Microsoft"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </S.ContainerCard>
      </S.Part>
    </S.Container>
  );
}

export default Login;
